import Actions from 'actions';

const initialState = Object.freeze({});

function resetPassword(state = initialState, action) {
  switch (action.type) {
    case Actions.RESET_PASSWORD_REQUEST:
      return initialState;
    case Actions.RESET_PASSWORD_SUCCESS:
      return {
        ...initialState,
        data: action.data,
      };
    case Actions.RESET_PASSWORD_FAIL:
      return {
        ...initialState,
        error: action.error,
      };
    default:
      return state;
  }
}

export default resetPassword;
